import { toast } from "sonner";

const FileSizeExtension = (data: any, type: string) => {
  if (type === "photo") {
    const allowed_file_size = 100;
    if (data.size / (1024 * 1024) > allowed_file_size) {
      toast.error("File too large");
      return false;
    } else {
      const array_of_allowed_files = ["png", "jpeg", "jpg", "pdf"];
      const file_extension = data.name.slice(
        ((data.name.lastIndexOf(".") - 1) >>> 0) + 2
      );
      if (!array_of_allowed_files.includes(file_extension)) {
        toast.error("Invalid file format");
        return false;
      } else {
        return true;
      }
    }
  } else if (type === "brochure") {
    const allowed_file_size = 100;
    if (data.size / (1024 * 1024) > allowed_file_size) {
      toast.error("File too large");
      return false;
    } else {
      const array_of_allowed_files = ["png", "jpeg", "jpg", "pdf"];
      const file_extension = data.name.slice(
        ((data.name.lastIndexOf(".") - 1) >>> 0) + 2
      );
      if (!array_of_allowed_files.includes(file_extension)) {
        toast.error("Invalid file");
        return false;
      } else {
        return true;
      }
    }
  } else if (type === "pdf") {
    const allowed_file_size = 100;
    if (data.size / (1024 * 1024) > allowed_file_size) {
      toast.error("File too large");

      return false;
    } else {
      const array_of_allowed_files = ["xlsx", "xls"];
      const file_extension = data.name.slice(
        ((data.name.lastIndexOf(".") - 1) >>> 0) + 2
      );
      if (!array_of_allowed_files.includes(file_extension)) {
        toast.error("Invalid file");

        return false;
      } else {
        return true;
      }
    }
  }
};
export default FileSizeExtension;
